var map = {
	"./Book-1T.jpg": 8825,
	"./Book-2T.jpg": 4000,
	"./Book-3T.jpg": 1951,
	"./Book-4T.jpg": 4102,
	"./Book-5T.jpg": 981,
	"./Book-6T.jpg": 4588,
	"./Book-7T.jpg": 2667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5523;